if (typeof Itinsy == "undefined") { Itinsy = {} }

Itinsy.MarketingMessage = {
	dismiss: function(el, id) {
		Itinsy.Cookies.createCookie("message_dismiss", id)
		$(el).closest("#marketing-alert").hide();
	}
}